import { render, staticRenderFns } from "./Error401.vue?vue&type=template&id=12b0b8ec&scoped=true&lang=pug&"
import script from "./Error401.vue?vue&type=script&lang=ts&"
export * from "./Error401.vue?vue&type=script&lang=ts&"
import style0 from "./Error401.vue?vue&type=style&index=0&id=12b0b8ec&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12b0b8ec",
  null
  
)

export default component.exports